import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function WelcomeBar() {
  const [hostelId] = useState(
    JSON.parse(localStorage.getItem("hostel") || "{}"),
  );

  return (
    <div className="d-flex justify-content-between align-items-center p-3 rounded shadow-sm mb-4">
      <div>
        <h4 className="mb-0">
          Welcome to{" "}
          <span className="text-primary fw-bold">{hostelId?.name}</span>
        </h4>
        <small className="text-muted">
          Manage your hostel easily from here.
        </small>
      </div>
      <div>
        <Link to="/hostel/list" className="btn btn-primary btn-sm">
          Go to Hostel List
        </Link>
      </div>
    </div>
  );
}
